var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBathroom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 135,
    viewBox: "0 0 136 135",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M129.2 81V87.75C129.2 100.642 121.924 111.847 111.18 117.517L115.6 135H102L98.6 121.5H37.4L34 135H20.4L24.82 117.517C19.3745 114.65 14.8193 110.363 11.6443 105.119C8.46924 99.8737 6.79446 93.869 6.8 87.75V81H0V67.5H122.4V20.25C122.4 18.4598 121.684 16.7429 120.408 15.477C119.133 14.2112 117.403 13.5 115.6 13.5C112.2 13.5 109.616 15.795 108.8 18.8325C113.084 22.4775 115.6 27.8775 115.6 33.75H74.8C74.8 28.3794 76.9493 23.2287 80.775 19.4311C84.6008 15.6335 89.7896 13.5 95.2 13.5H96.356C99.144 5.67 106.692 0 115.6 0C121.01 0 126.199 2.13348 130.025 5.93109C133.851 9.7287 136 14.8794 136 20.25V81H129.2ZM115.6 81H20.4V87.75C20.4 93.1206 22.5493 98.2713 26.375 102.069C30.2008 105.867 35.3896 108 40.8 108H95.2C100.61 108 105.799 105.867 109.625 102.069C113.451 98.2713 115.6 93.1206 115.6 87.75V81Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBathroom);
export default __webpack_public_path__ + "static/media/bathroom.12ca70c7d2c8282b339268ae52b0acc3.svg";
export { ForwardRef as ReactComponent };